import { insensitive } from '@acme/common'

interface ItemCatalogo {
    label: string
    descricao: string
    grupo: string
}

/** Agrupa os itens cujo nome ou descrição contém `busca`, na ordem do catálogo. */
export function agruparCatalogo<TId extends string, TItem extends ItemCatalogo>(
    catalogo: Record<TId, TItem>,
    busca: string,
): [TItem['grupo'], TId[]][] {
    const termo = insensitive(busca)
    const grupos = new Map<TItem['grupo'], TId[]>()

    for (const [id, item] of Object.entries(catalogo) as [TId, TItem][]) {
        const texto = insensitive(`${item.label} ${item.descricao}`)
        if (!texto.includes(termo)) continue
        grupos.set(item.grupo, [...(grupos.get(item.grupo) ?? []), id])
    }

    return [...grupos]
}
